<template>
  <ife-container
    id="main"
    :class="companyCssClass"
    fluid
  >
    <showcase-company-logo />
    <ife-row align-h="center">
      <ife-col
        cols="12"
        md="7"
        lg="5"
        class="mt-4"
      >
        <ife-card
          v-if="complete"
          title="Thank you"
          :class="`ife-card ${companyCssClass}`"
        >
          <p>
            You have successfully reset your password.
          </p>

          <p>
            <b-btn
              variant="primary"
              @click="goBackToLogin()"
            >
              Go to Login
            </b-btn>
          </p>
        </ife-card>
        <b-overlay
          v-else
          :show="loading"
        >
          <ife-card
            title="Reset your password"
            :class="`ife-card ${companyCssClass}`"
          >
            <b-alert
              v-if="error"
              variant="danger"
              show
            >
              {{ error }}
            </b-alert>
            <validation-observer
              ref="resetPasswordFormObserver"
              v-slot="v"
              name="Password"
            >
              <ife-form @submit="v.handleSubmit(submit)">
                <validation-provider
                  v-slot="{ errors }"
                  vid="password"
                  name="password"
                  :bails="false"
                  :rules="
                    {
                      required: true,
                      min: 8,
                      has_upper_case: true,
                      has_lower_case: true,
                      has_symbol: true,
                      has_digit: true,
                      regex: passwordRegex,
                    }"
                >
                  <b-form-group>
                    <b-form-input
                      v-model="password"
                      :state="getValidationState(v)"
                      placeholder="New Password"
                      type="password"
                    />
                    <b-form-invalid-feedback>
                      <ul v-if="errors.length">
                        <li
                          v-for="(error, index) in errors"
                          :key="index"
                        >
                          {{ error }}
                        </li>
                      </ul>
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <validation-provider
                  v-slot="{ errors }"
                  name="Confirm Password"
                  rules="required|confirm:@password"
                >
                  <b-form-group>
                    <b-form-input
                      v-model="confirmPassword"
                      :state="getValidationState(v)"
                      placeholder="Confirm New Password"
                      type="password"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>

                <template #buttons>
                  <b-btn
                    size="sm"
                    variant="primary"
                    type="submit"
                    :disabled="false"
                  >
                    Reset
                  </b-btn>
                  <b-btn
                    size="sm"
                    variant="secondary"
                    @click="goBackToLogin()"
                  >
                    Cancel
                  </b-btn>
                </template>
              </ife-form>
            </validation-observer>
          </ife-card>
        </b-overlay>
      </ife-col>
    </ife-row>
  </ife-container>
</template>

<script>
import CompanyLoginMixin from '@/Client/Mixin/CompanyLogin';
import Regex from '@/Client/Store/Regex';
import ShowcaseCompanyLogo from '@/Client/Page/ShowcaseCompanyLogo.vue';

export default {
  name: 'ResetPassword',
  components: {
    'showcase-company-logo': ShowcaseCompanyLogo,
  },
  mixins: [CompanyLoginMixin],
  data() {
    return {
      complete: false,
      confirmPassword: null,
      error: null,
      loading: false,
      password: null,
      passwordRegex: Regex.password,
      token: null,
    };
  },
  computed: {
  },
  mounted() {
    if (!this.$route.query.token) {
      this.$router.push({name: 'login'});
    }

    this.token = this.$route.query.token;
  },
  methods: {
    goBackToLogin() {
      const name = this.hasCompanyLogin ? 'companyLogin' : 'login';
      const params = this.hasCompanyLogin ? {company: this.companyLogin.name} : {};

      this.$router.push({name: name, params: params});
    },
    submit() {
      this.loading = true;
      this.error = null;

      this.axios.post(
          `${process.env.CORE_API_URL}/reset-password/${this.token}`,
          {
            password: this.password,
            token: this.token,
            verify: this.confirmPassword,
          },
      )
          .then(() => {
            this.complete = true;
          })
          .catch((error) => {
            if (error.response && error.response.data.error) {
              this.error = error.response.data.error;
              return;
            }

            this.error = 'Something went wrong, please try again.';
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
};
</script>

<style scoped>

</style>
